import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Alert } from 'reactstrap';
import { HeadlineNumber } from '../../../components/UI/HeadlineNumber';
import { StackedChart } from './StackedChart';

export class NestEggPanel extends Component {
    render() {
        var profitAndCapital = this.props.growthProfitTotal + this.props.growthCapitalTotal;

        return (
            <Card className="panel-card">
                <CardBody>
                    <Row>
                        <Col xs="12" className="chart-container" data-testid="nestEggPanel">
                            {this.props.incomeNet >= 0 ? <StackedChart
                                capital={this.props.growthCapitalByYear}
                                profit={this.props.incomeNet}
                                /> :
                                <Alert color="danger">
                                    <span data-testid="chartDisabledNegativeProfit" >Our comparison chart has been disabled due to a negative net profit.</span>
                                </Alert>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="6">
                            <HeadlineNumber
                                title="15 year return"
                                valuePounds={profitAndCapital}
                                value={!profitAndCapital > 0 && '£0'}
                                description='Profit + capital growth'
                            />
                        </Col>
                        <Col xs="6">
                            <HeadlineNumber
                                title="ROI"
                                value={this.props.roi + '%'}
                                description='Net profit &divide; purchase costs'
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="6">
                            <HeadlineNumber
                                title="Net profit"
                                valuePounds={this.props.growthProfitTotal}
                                value={!this.props.growthProfitTotal > 0 && '£0'}
                                description='Gross profit - mortgage'
                            />
                        </Col>
                        <Col xs="6">
                            <HeadlineNumber
                                title="Capital growth"
                                valuePounds={this.props.growthCapitalTotal}
                                value={!this.props.growthCapitalTotal > 0 && '£0'}
                                description='5% YoY growth'
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/NestEggPanel.jsx